const getErrorMessage = (type, errors) => {
  const errorFiltered = errors.filter((error) => error.propertyPath === type);

  return errorFiltered.map((error) => error.message).join(' ');
};

export default getErrorMessage;
